import { Component, ViewEncapsulation, OnInit, ViewChild } from '@angular/core';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { KYMW1320Model } from './kymw1320.model';
import { PlessViewUtilsSub } from '../../../commons/kymw00/pless-view-utils-sub.service';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { SaveInspectListService } from './api-services/save-inspect-list.service';
import { FileDownloadConfirmService } from '../../../commons/kymw02/file-download-confirm/file-download-confirm.service';
import { PlessDialogServiceSub } from 'src/app/commons/kymw00/pless-dialog-service-sub';
import { GetPlanGoodsMediumtService } from '../kymw1300/api-services/get-plan-goods-medium.service';
import { GetBundleCatalogRoundInfoListService } from '../kymw1300/api-services/get-bundle-catalog-round-info-list.service';
import { BundleCatalogRoundInfoListModel } from '../kymw1300/vo/bundle-catalog-round-info-list.model';
import { OrderCodeTextInputComponent } from 'src/app/commons/kymw02/text-input/order-code-text-input/order-code-text-input.component';

/**
 * プロモ商品企画点検リスト画面を管理するクラス
 *
 * @export KYMW1320Component
 * @class KYMW1320Component
 */
@Component({
  selector: 'app-kymw1320',
  templateUrl: 'kymw1320.component.html',
  styleUrls: ['kymw1320.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class KYMW1320Component extends PlessViewHelperSub implements OnInit {
  kymw1320Model: KYMW1320Model = new KYMW1320Model();
  isDisabledBundleCatalog: boolean = true;

  private readonly OUTPUTFLG_NVAL: string = "1";
  private readonly OUTPUTFLG_PREORDER: string = "2";

  /**
   *Creates an instance of KYMW1320Component.
   * @param {KYMW00Model} kymw00Model
   * @param {SaveInspectListService} saveInspectListService
   * @param {FileDownloadConfirmService} fileDownloadConfirmService
   * @memberof KYMW1320Component
   */
  constructor(
    private kymw00Model: KYMW00Model,
    public saveInspectListService: SaveInspectListService,
    public fileDownloadConfirmService: FileDownloadConfirmService,
    public dialogService: PlessDialogServiceSub,
    public getPlanGoodsMediumtService: GetPlanGoodsMediumtService,
    public getBundleCatalogRoundInfoListService: GetBundleCatalogRoundInfoListService,
  ) {
    super(kymw00Model);
  }

  @ViewChild('txt_StartOrderCode', { static: true }) txt_StartOrderCode: OrderCodeTextInputComponent;
  @ViewChild('txt_EndOrderCode', { static: true }) txt_EndOrderCode: OrderCodeTextInputComponent;

  /**
   * 初期処理
   *
   * @memberof KYMW1320Component
   */
  public ngOnInit() {
    this.componentName = 'KYMW1320';
    this.kymw1320Model.kymw1320Component = this;

    this.getPlanGoodsMediumtService.execute(this.kymw1320Model, (data: any) => {
      // 媒体コンボボックスのフィルタリング（初期値はNVAL）
      this.eventOutputFlag_CHANGEHandler();
    });
  }

  /**
   * 媒体の対象ラジオボタン 変更時
   * 
   * @memberof KYMW1320Component
   */
  public eventOutputFlag_CHANGEHandler() {
    // ラジオボタンの選択に応じて媒体リストをフィルタリング
    if (this.kymw1320Model.outputFlag === this.OUTPUTFLG_NVAL) {
      this.kymw1320Model.dispMediumTypeList = this.kymw1320Model.mediumTypeList.filter((medium, i) => i === 0 || medium.MediumGroupDiv === this.kymw00Model.MEDIUM_GROUP_DIV_NVAL);
    } else if (this.kymw1320Model.outputFlag === this.OUTPUTFLG_PREORDER) {
      this.kymw1320Model.dispMediumTypeList = this.kymw1320Model.mediumTypeList.filter((medium, i) => i === 0 || medium.MediumGroupDiv === this.kymw00Model.MEDIUM_GROUP_DIV_PREORDER);
    }
    this.kymw1320Model.selectedMediumType = '';
    this.eventMediumType_CHANGEHandler();
  }

  /**
   * 媒体区分変更時
   * 
   * @memberof KYMW1320Component
   */
  public eventMediumType_CHANGEHandler(): void {
    // 媒体選択時に束ね企画回を活性化
    this.isDisabledBundleCatalog = PlessViewUtilsSub.isEmpty(this.kymw1320Model.selectedMediumType);

    this.clearBundle();
    if (!this.isDisabledBundleCatalog) {
      this.getBundleCatalogList();
    }
  }

  /**
   * 束ね企画回情報クリア
   * 
   * @memberof KYMW1320Component
   */
  private clearBundle(): void {
    this.kymw1320Model.selectBundleCatalogRound = '';
    this.kymw1320Model.dispBundleCatalogRoundInfoList = [];
    this.kymw1320Model.startBundleOrderCode = '';
    this.kymw1320Model.endBundleOrderCode = '';
  }

  /**
   * 束ね企画情報取得
   * 
   * @memberof KYMW1320Component
   */
  private getBundleCatalogList(): void {
    const vo = { mediumType: this.kymw1320Model.selectedMediumType };
    this.getBundleCatalogRoundInfoListService.execute(vo, (data: any) => {
      this.kymw1320Model.dispBundleCatalogRoundInfoList = data.BundleCatalogRoundList;
      // 先頭に空を追加
      this.kymw1320Model.dispBundleCatalogRoundInfoList.unshift(new BundleCatalogRoundInfoListModel());
    });
  }

  /**
   * 束ね企画回変更時
   * 
   * @memberof KYMW1320Component
   */
  public eventBundleCatalogGuideStandardName_CHANGEHandler(): void {
    const selectBundle =
      this.kymw1320Model.dispBundleCatalogRoundInfoList.find(item => item.BundleCatalogRoundId === this.kymw1320Model.selectBundleCatalogRound);
    this.kymw1320Model.startBundleOrderCode = selectBundle?.StartOrderCode ?? '';
    this.kymw1320Model.endBundleOrderCode = selectBundle?.EndOrderCode ?? '';
  }

  /**
   * 出力ボタン押下時
   *
   */
  public eventOutput_CLICKHandler(): void {
    if (!this.validation()) return;

    const vo = {
      mediumType: this.kymw1320Model.selectedMediumType,
      // 開始受注コードが未入力の場合、束ねの開始受注コードを適用
      startOrderCode: this.kymw1320Model.startOrderCode || this.kymw1320Model.startBundleOrderCode,
      // 終了受注コードが未入力の場合。束ねの終了受注コードを適用
      endOrderCode: this.kymw1320Model.endOrderCode || this.kymw1320Model.endBundleOrderCode,
      pCode: this.kymw1320Model.pCode,
      itemCode: this.kymw1320Model.itemCode,
      orderNum: this.kymw1320Model.orderNum,
      bundleCatalogRoundId: this.kymw1320Model.selectBundleCatalogRound,
      outputFlag: this.kymw1320Model.outputFlag,
    };

    // API呼び出し
    this.saveInspectListService.execute(vo, (data: any) => {
      let fileName = "";
      // ファイル名の設定
      if (vo.outputFlag == this.OUTPUTFLG_NVAL) {
        fileName = '1物N価商品企画点検リスト_';
      } else if (vo.outputFlag == this.OUTPUTFLG_PREORDER) {
        fileName = '予約商品企画点検リスト_';
      }

      fileName = fileName + PlessViewUtilsSub.formatedNowDate('YYYYMMDD_hhmmss') + '.xlsx';

      this.fileDownloadConfirmService.show(data.FileName, fileName);
    });
  }

  private validation(): boolean {
    // 束ね企画名、受注コードがどちらも未入力の場合
    if (PlessViewUtilsSub.isEmpty(this.kymw1320Model.selectBundleCatalogRound)
      && PlessViewUtilsSub.isEmpty(this.kymw1320Model.startOrderCode)
      && PlessViewUtilsSub.isEmpty(this.kymw1320Model.endOrderCode)) {
      this.dialogService.openAlertGetMessage('E0663');
      return false;
    }

    // 妥当性チェック：受注コード(From)、受注コード(To)、受注コード(From)か受注コード(To)どちらかのみ入力された場合 
    if ((!PlessViewUtilsSub.isEmpty(this.kymw1320Model.startOrderCode) && !this.txt_StartOrderCode.isValidOrderCode())
      || (!PlessViewUtilsSub.isEmpty(this.kymw1320Model.endOrderCode) && !this.txt_EndOrderCode.isValidOrderCode())
      || (PlessViewUtilsSub.isEmpty(this.kymw1320Model.startOrderCode) && !PlessViewUtilsSub.isEmpty(this.kymw1320Model.endOrderCode))
      || ((!PlessViewUtilsSub.isEmpty(this.kymw1320Model.startOrderCode) && PlessViewUtilsSub.isEmpty(this.kymw1320Model.endOrderCode)))) {
      this.dialogService.openAlertGetMessage('W0024', ['受注コード']);
      return false;
    }

    // 受注コード順序チェック
    if (this.kymw1320Model.startOrderCode > this.kymw1320Model.endOrderCode) {
      this.dialogService.openAlertGetMessage('E0125', ['受注コード(From)', '受注コード(To)']);
      return false;
    }

    return true;
  }
}
